import { useContext, useMemo } from 'react';
import { AuthContext } from '../../context/auth';
import { crearApiCrHttp, crearApiHttp, FacturacionElectronica, OpcionesApi } from '../../modules/facturacionElectronica';
import '../../modules/facturacionElectronica/estilos.css';

// Las rutas del módulo ya incluyen /api/pa/fe, /api/cr/fe y /api/fe, así que la base es el servidor del API
// (REACT_APP_API_URL sin el sufijo /api). Swiftmart.API las reenvía a SwiftWebApi con el token del Wallet de la
// sesión (el que trae el claim "empresa"); el navegador solo envía el JWT de Swiftmart.
const baseUrl = (process.env.REACT_APP_API_URL ?? '').replace(/\/api\/?$/, '').replace(/\/$/, '');

const opciones: OpcionesApi = {
    baseUrl,
    obtenerToken: () => localStorage.getItem('token'),
};

// Configuración de facturación electrónica del comercio en sesión. Menú "Facturación electrónica" (recurso
// electronic-invoice-settings): administrador del comercio con la funcionalidad de factura electrónica.
export const ElectronicInvoiceSettingsPage = () => {
    const { user } = useContext(AuthContext);
    const idEmpresa = user?.merchant?.id;

    const apiPanama = useMemo(() => crearApiHttp(opciones), []);
    const apiCostaRica = useMemo(() => crearApiCrHttp(opciones), []);

    if (!idEmpresa) {
        return (
            <div className="container py-4">
                <div className="alert alert-warning">La facturación electrónica se configura con un usuario de comercio.</div>
            </div>
        );
    }

    return (
        <div className="fe-modulo">
            <FacturacionElectronica apiPanama={apiPanama} apiCostaRica={apiCostaRica} idEmpresa={idEmpresa} />
        </div>
    );
};
